import styled from "styled-components";
import Colors from "../../constants/Colors";

export const ContainerCollaboratorInitial = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-top: 20px;

  @media screen and (max-width: 1200px) {
    margin: 20px;
  }
`;

export const FlexRow = styled.div.attrs({ className: "flex" })`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  overflow: hidden;

  @media screen and (max-width: 900px) {
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DoubleComponents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-right: 0px;
`;

export const ViewAll = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  font-size: 16px;
  border: none;
  color: #0a5190;
  cursor: pointer;
  width: 93px;
`;

export const ViewScroll = styled.div`
  display: flex;
  width: 100%;
  overflow: scroll;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ButtonMarkConsulta = styled.button<{
  color?: string;
  inverted?: boolean;
  isTablet?: boolean;
}>`
  background-color: ${(props) =>
    props.color ? props.color : props.inverted ? "#E0F0F5" : Colors.lightBlue};
  display: flex;
  color: ${(props) => (props.inverted ? Colors.SPM600 : "white")};
  width: ${(props) => (props.isTablet ? "100%" : "auto")};
  flex-direction: row;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  padding: 10px 18px;
  gap: 8px;
  border: none;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  letter-spacing: 0.2px;
  margin-top: 0px;
  height: 42px;
  margin-right: 0px;
  box-shadow: 0 2px 6px rgba(10, 81, 144, 0.15);
  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
  }

  &:hover {
    cursor: ${(props) => (props.disabled ? "text" : "pointer")};
    background-color: #0d6cbf;
    box-shadow: 0 4px 12px rgba(10, 81, 144, 0.25);
  }

  &:active {
    background-color: ${(props) => (props.disabled ? "" : "#D7DDF4")};
    color: ${(props) => (props.disabled ? "" : Colors.lightBlue)};
    border-color: ${(props) => (props.disabled ? "" : "#D7DDF4")};
  }

  @media screen and (min-width: 900px) and (max-width: 1225px) {
    width: 100%;
  }


`;
